function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import { memo } from 'react';
import PropTypes from 'prop-types';
import useThemeProps from "../../hooks/useThemeProps";

function SvgHydrogenHydrogenOutlinedIcon(props) {
  var c = useThemeProps();
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    width: props.size || '1em',
    height: props.size || '1em'
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 1a.5.5 0 0 1 .5.5v13a.5.5 0 0 1-1 0v-13a.5.5 0 0 1 .5-.5ZM10.5 1a.5.5 0 0 1 .5.5v13a.5.5 0 0 1-1 0v-13a.5.5 0 0 1 .5-.5ZM13.5 11.5c-.322 0-.5.222-.5.5a.5.5 0 0 1-1 0c0-.744.543-1.5 1.5-1.5.96 0 1.5.77 1.5 1.5 0 .33-.078.6-.216.834-.126.215-.295.383-.426.515l-.005.005c-.33.33-.517.516-.65.646h.797a.5.5 0 1 1 0 1h-2a.5.5 0 0 1-.357-.85c.465-.475.564-.572.757-.762.14-.138.33-.325.746-.742.144-.143.223-.228.276-.319A.602.602 0 0 0 14 12c0-.27-.181-.5-.5-.5Z",
    fill: c[props.fill] || props.fill || "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 7.5h8v1H2v-1Z",
    fill: c[props.fill] || props.fill || "currentColor"
  }));
}

SvgHydrogenHydrogenOutlinedIcon.propTypes = {
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};
var Memo = /*#__PURE__*/memo(SvgHydrogenHydrogenOutlinedIcon);
export default Memo;